export class SubmissionEvent {
  id: number;
  submitterEmail: string;
  documentGuid: string;
  friendlyError: string;
  error: string;
  userAgent: string;
  submissionCount: number;
  webFormSubmission: string;
}
